import {useTranslation, Trans} from 'react-i18next';
import Lottie from 'lottie-react';
import {InfoIcon} from 'lucide-react';
import {useLazyImport} from '@chekin/core';
import {Alert, cn} from '@chekin/guestapp-ui-kit';

function ScanDocument() {
  const {t} = useTranslation();
  const {getLazyValue: getKioskoAnimation} = useLazyImport(
    () => import('../../../../assets/lotties/animations/kiosko-front-side.json'),
  );
  const animationData = getKioskoAnimation();

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className="rounded-[36px] mb-[75px]">
        {animationData && (
          <Lottie
            animationData={animationData}
            className="w-[778px] h-[545px] rounded-[28px] overflow-hidden"
          />
        )}
      </div>
      <div className="rounded-2xl border border-black/10 p-9 grid gap-9 w-full">
        <span className="not-italic font-medium leading-[56.719px] kiosko:text-kiosko-m text-primary">
          {t('instructions')}
        </span>
        <div className="flex flex-col gap-9">
          <div className="text-kiosko-s">
            <Trans i18nKey="place_passport_facing_down" components={[<b />]} />
          </div>
          <div className="text-kiosko-s">{t('tap_scan_document')}</div>
        </div>

        <Alert
          className={cn(
            'text-[var(--primary)] [--lucide-stroke-width:3] max-w-[400px] text-left flex gap-3 mb-6',
            'max-w-full p-[18px_38px_18px_18px] !text-kiosko-s leading-[56px]',
            'rounded-[24px]',
          )}
        >
          <div className="kiosko:p-1">
            <InfoIcon className="h-5 w-5 kiosko:h-10 kiosko:w-10" />
          </div>
          <span className="kiosko:pl-6">
            {t('make_sure_the_document_properly_lies_flat')}
          </span>
        </Alert>
      </div>
    </div>
  );
}

export {ScanDocument};
